import { uniqueId } from 'lodash';

export const LIGHTBOX_OPEN = 'Rollo/LIGHTBOX_OPEN';
export const LIGHTBOX_UPDATE = 'Rollo/LIGHTBOX_UPDATE';
export const LIGHTBOX_CLOSE = 'Rollo/LIGHTBOX_CLOSE';
export const LIGHTBOX_CLOSE_ALL = 'Rollo/LIGHTBOX_CLOSE_ALL';

export type ShipmentLabelMode = 'single' | 'groupedShipments' | 'multi';

export interface OpenLightboxDocument {
  name: string;
  blob?: Blob;
  url?: string;
  noticeHtml?: string;
  documentType?: 'shipmentLabel' | 'packingSlip';
  labelMode?: ShipmentLabelMode;
  trackingNumbers?: string[];
  loading?: boolean;
}

export interface LightboxDocument extends OpenLightboxDocument {
  id: string;
}

export const openDoc = (doc: OpenLightboxDocument) => {
  return {
    type: LIGHTBOX_OPEN,
    payload: {
      id: uniqueId('doc_'),
      ...doc,
    },
  };
};

export const updateDoc = (id: string, doc: Partial<OpenLightboxDocument>) => {
  return {
    type: LIGHTBOX_UPDATE,
    payload: {
      id,
      ...doc,
    },
  };
};

export const closeDoc = (id) => {
  return {
    type: LIGHTBOX_CLOSE,
    payload: {
      id,
    },
  };
};

export const closeAll = () => {
  return {
    type: LIGHTBOX_CLOSE_ALL,
  };
};
